import IFrameHolderFields from './IFrameHolderFields'
export default IFrameHolderFields
